/**
 * Tilled Admin API
 *
 * Contact: integrations@tilled.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProductCode } from './productCode';
import { AccountRequirementsError } from './accountRequirementsError';
import { PaymentProviderAttributes } from './paymentProviderAttributes';
import { PricingTemplate } from './pricingTemplate';


export interface AccountCapability { 
    /**
     * The collection of optional or required attributes for onboarding and operation.
     */
    attributes?: PaymentProviderAttributes;
    /**
     * Unique identifier for the object.
     */
    id: string;
    /**
     * The percentage of required fields completed in the onboarding application.
     */
    onboarding_application_progress: number;
    /**
     * The URL for the merchant\'s onboarding application.
     */
    onboarding_application_url?: string;
    /**
     * The pricing applied to/associated with this account.
     */
    pricing_template: PricingTemplate;
    /**
     * *Deprecated: See `pricing_template` for account details.*  The capability applied to/associated with this account.
     * @deprecated
     */
    product_code: ProductCode;
    /**
     * The fields that need to be collected again because validation failed for some reason.
     */
    requirements_errors: Array<AccountRequirementsError>;
    /**
     * Status of the associated capability as part of the onboarding process. Only the `active` status represents that payments can be handled by this account for this given capability.  `created` The capability has been created but no further action taken. Generally, this is the state of all capabilities when a merchant has been created but the onboarding process has not yet started.  `started` The onboarding process has been started but not yet submitted.  `submitted` The onboarding process for this capability has been submitted.  `active` This associated capability is active for payments on this account.  `disabled` This associated capability is not valid for payments on this account.
     */
    status: AccountCapability.StatusEnum;
}
export namespace AccountCapability {
    export type StatusEnum = 'created' | 'started' | 'submitted' | 'active' | 'disabled' | 'in_review' | 'rejected' | 'withdrawn';
    export const StatusEnum = {
        CREATED: 'created' as StatusEnum,
        STARTED: 'started' as StatusEnum,
        SUBMITTED: 'submitted' as StatusEnum,
        ACTIVE: 'active' as StatusEnum,
        DISABLED: 'disabled' as StatusEnum,
        IN_REVIEW: 'in_review' as StatusEnum,
        REJECTED: 'rejected' as StatusEnum,
        WITHDRAWN: 'withdrawn' as StatusEnum
    };
}


